import { t } from 'utilities/TranslationUtils';

//  global components
import Dialog from '@mui/material/Dialog';
import { AppButton } from 'components/form';
import CircularProgress from '@mui/material/CircularProgress';

export type AppConfirmDialogPropsType = {
  isDialogOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  loadingStateTitle?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  message?: string;
  className?: string;
  footerNote?: string;
  isLoading?: boolean;
  dataTest?: string;
  variant?: 'primary' | 'danger';
};

const AppConfirmDialog = ({
  isDialogOpen,
  onConfirm,
  onCancel,
  title = '',
  loadingStateTitle = '',
  confirmBtnText: confirmLabel = t('yes'),
  cancelBtnText: cancelLabel = t('no'),
  message = '',
  className = '',
  footerNote = '',
  isLoading = false,
  dataTest = '',
  variant = 'danger',
}: AppConfirmDialogPropsType) => {
  return (
    <Dialog
      maxWidth={'xs'}
      fullWidth
      className={`app-confirm-dialog ${className}`}
      open={isDialogOpen}
      onClose={() => !isLoading && onCancel()}
      data-test={dataTest || 'testing-app-confirm-dialog'}
    >
      <>
        {isLoading ? (
          <div className='card'>
            <header className='p-3 border-bottom'>
              <h3 className='font-22 font-500 text-uppercase mb-0 text-uppercase font-22 font-500'>
                {loadingStateTitle || t('common.loading')}, {t('common.please_wait')}...
              </h3>
            </header>
            <div className='p-5 d-flex align-items-center justify-content-center'>
              <CircularProgress />
            </div>
          </div>
        ) : (
          <div className='card p-0'>
            <header className='p-3 border-bottom mb-0'>
              <h3 className='font-22 font-500 text-uppercase mb-0 text-uppercase font-22 font-500'>{title}</h3>
            </header>
            {message && (
              <div className='body card-body  p-3'>
                <p className='mb-0'>{message}</p>
              </div>
            )}
            <footer className='p-3 pb-0 border-top d-flex align-items-center justify-content-between'>
              <small className='text-danger'>{footerNote}</small>
              <div className='d-flex'>
                <AppButton variant='secondary' onClick={() => onCancel()} data-test='testing-app-confirm-dialog-cancel-button'>
                  {cancelLabel}
                </AppButton>
                <AppButton
                  variant={variant}
                  className=' ml-2'
                  onClick={() => onConfirm()}
                  data-test='testing-app-confirm-dialog-confirm-button'
                >
                  {confirmLabel}
                </AppButton>
              </div>
            </footer>
          </div>
        )}
      </>
    </Dialog>
  );
};

export default AppConfirmDialog;
